/* eslint-disable react/display-name */
import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { selectedBackgroundFillColor, unselectedBackgroundFillColor } from '../icons/iconUtilities';
import { MapLayerListItemType } from '../utilities/interfaces';

let backgroundFillColor: string;

export const MapLayerListItem = forwardRef<HTMLLIElement, MapLayerListItemType>(({
    layerId,
    currentLayerId,
    layerLabel,
    layerSponsored,
    IconComponent,
    onLayerPressed
}, ref ) => {
    if (currentLayerId === layerId) {
        backgroundFillColor = selectedBackgroundFillColor;
    } else {
        backgroundFillColor = unselectedBackgroundFillColor;
    }

    return (
        <MapLayerListItemContainer
            ref={ref}
            onClick={() => {
                onLayerPressed(layerId);
            }}>
            <IconWrapper>
                <IconComponent 
                    backgroundFillColor={backgroundFillColor} />
            </IconWrapper>
            <span>
                {layerLabel}
                {!!layerSponsored && <SponsorshipText><br />
                    {!!layerSponsored}
                </SponsorshipText>
                }
            </span>
        </MapLayerListItemContainer>
    );
});

const MapLayerListItemContainer = styled.li`
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 15px;
    display: flex;
    align-items: center;
    
    cursor: pointer;
    &:hover {
        background-color: #EEEEEE;
    }
`;

const IconWrapper = styled.div`
    width: 40px;
    margin-right: 10px;
`;

const SponsorshipText = styled.span`
    font-size: 10px;
`;